<template>
	<a class="btn-rs" :href="url" target="_blank" :class="icone">
		<i :class="'fa fa-' + icone" aria-hidden="true"></i>
	</a>
</template>

<script>
/**
 * Composant permettant d'afficher une icone de réseau social
 */
export default {
	name: 'BtnRS',
	props: {
		/**
		 * Le type d'icone font-awesome 4.7
		 */
		icone: {
			type: String,
		},
		/**
		 * L'url du bouton
		 */
		url: {
			type: String,
			default: '',
		},
	},
};
</script>

<style lang="scss" scoped>
@import '~@scss/_vars.scss';

.btn-rs {
	display: flex;
	justify-content: center;
	align-items: center;
	width: 45px;
	height: 45px;
	font-size: 20px;
	border: none;
	border-radius: 50px;
	border: 2px solid transparent;
	color: white;
	cursor: pointer;
	text-decoration: none;
	transition: all 0.3s ease-in-out;

	&.--size-40 {
		width: 40px;
		height: 40px;
		font-size: 18px;
	}

	&.facebook {
		background-color: #4867aa;

		&:hover {
			color: #4867aa;
			border-color: #4867aa;
		}
	}

	&.twitter {
		background-color: #30a0f1;

		&:hover {
			color: #30a0f1;
			border-color: #30a0f1;
		}
	}

	&.linkedin {
		background-color: #0274b3;

		&:hover {
			color: #0274b3;
			border-color: #0274b3;
		}
	}

	&.envelope {
		background-color: #3c3c3b;

		&:hover {
			color: #3c3c3b;
			border-color: #3c3c3b;
		}
	}

	&:hover {
		background-color: #fff;
		border-color: transparent;
	}

	&.--bg-transparent {
		background-color: transparent;

		&:hover {
			background-color: #fff;
			color: $secondaryColor;
		}
	}

	&.--border-orange {
		border: 2px solid $secondaryColor;
	}
}
</style>


// WEBPACK FOOTER //
// src/components/global/Btn-rs.vue